import { render, staticRenderFns } from "./AddKeysModal.vue?vue&type=template&id=7b63d9f8&"
import script from "./AddKeysModal.vue?vue&type=script&lang=ts&"
export * from "./AddKeysModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports